export const enplast = {
  enplast_discrepancy_item_productclient_unitprice_mismatch: `El precio '{{2}}' del artículo '{{1}}' no coincide con el precio definido '{{3}}'`,
};
